/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

export const PII_FILTER_ACTION = {
  REDACT: 'redact',
  MASK: 'mask'
};

export const PII_FILTER_ACTION_OPTIONS = [PII_FILTER_ACTION.REDACT, PII_FILTER_ACTION.MASK];

export const PII_FILTER_ACTION_LABEL_KEY = {
  [PII_FILTER_ACTION.REDACT]: 'editNodeModal.PII_FILTER_ACTION_REDACT',
  [PII_FILTER_ACTION.MASK]: 'editNodeModal.PII_FILTER_ACTION_MASK'
};

export const PII_FILTER_DEFAULT_ACTION = PII_FILTER_ACTION.REDACT;

export const PII_FILTER_MIDDLEWARE_KEY = 'piiFilter';

export const PII_FILTER_ICON_TYPE = {
  PERSON: 'person',
  CREDIT_CARD: 'creditCard',
  EMAIL: 'email'
};

export const PII_FILTER_FIELD_KEYS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  CREDIT_CARD: 'creditcard',
  EMAIL: 'email'
};
